// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ProductDetailsPage.css */
.product-details-container {
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif;
  background-color: #f8fafc;
  min-height: 0;
  padding: 24px;
}

.product-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 32px;
  background-color: white;
  padding: 20px 24px;
  border-radius: 12px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
}

.header-left {
  display: flex;
  align-items: center;
  gap: 16px;
}

.back-button {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 8px 16px;
  background-color: transparent;
  border: 1px solid #e5e7eb;
  border-radius: 8px;
  cursor: pointer;
  color: #6b7280;
  font-size: 14px;
  transition: all 0.2s ease;
}

.back-button:hover {
  background-color: #f9fafb;
}

.header-title {
  margin: 0;
  font-size: 24px;
  font-weight: 600;
  color: #1f2937;
}

.header-buttons {
  display: flex;
  gap: 12px;
}

.edit-button {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 10px 16px;
  background-color: #ff6b35;
  color: white;
  border: none;
  border-radius: 8px;
  cursor: pointer;
  font-size: 14px;
  font-weight: 500;
  transition: all 0.2s ease;
}

.edit-button:hover {
  background-color: #e55a2b;
}

.delete-button {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 10px 16px;
  background-color: transparent;
  color: #ef4444;
  border: 1px solid #ef4444;
  border-radius: 8px;
  cursor: pointer;
  font-size: 14px;
  font-weight: 500;
  transition: all 0.2s ease;
}

.delete-button:hover {
  background-color: #fef2f2;
}

.product-content-con {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 32px;
  max-width: 100%;
  margin: 0 auto;
}

.images-container {
  background-color: white;
  border-radius: 12px;
  padding: 24px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
}

.images-title {
  margin: 0 0 20px 0;
  font-size: 18px;
  font-weight: 600;
  color: #1f2937;
}

.main-image-container {
  position: relative;
  margin-bottom: 16px;
  border-radius: 8px;
  overflow: hidden;
  background-color: #f3f4f6;
}

.main-image {
  width: 100%;
  height: 400px;
  object-fit: cover;
  display: block;
}

.nav-button {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  background-color: rgba(0, 0, 0, 0.6);
  color: white;
  border: none;
  border-radius: 50%;
  width: 40px;
  height: 40px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s ease;
}

.nav-button:hover {
  background-color: rgba(0, 0, 0, 0.8);
}

.prev-button {
  left: 12px;
}

.next-button {
  right: 12px;
}

.thumbnails-container {
  display: flex;
  gap: 12px;
  flex-wrap: wrap;
}

.thumbnail {
  width: 80px;
  height: 80px;
  object-fit: cover;
  border-radius: 6px;
  cursor: pointer;
  border: 2px solid transparent;
  transition: all 0.2s ease;
}

.thumbnail:hover {
  opacity: 0.9;
  transform: scale(1.05);
}

.thumbnail-active {
  border: 2px solid #ff6b35;
  opacity: 1;
}

.thumbnail-inactive {
  opacity: 0.7;
}

.info-column {
  display: flex;
  flex-direction: column;
  gap: 24px;
}

.info-card {
  background-color: #fee2e2;
  border-radius: 12px;
  padding: 24px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
}

.product-name {
  margin: 0 0 20px 0;
  font-size: 28px;
  font-weight: 700;
  color: #1f2937;
}

.info-items-container {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.info-item {
  display: flex;
  align-items: center;
  gap: 12px;
}

.info-icon {
  color: #6b7280;
}

.info-text {
  font-size: 16px;
  color: #6b7280;
  font-weight: 500;
}

.price-text {
  font-size: 24px;
  font-weight: 700;
  color: #10b981;
}

.quantity-text {
  font-size: 18px;
  font-weight: 600;
  color: #1f2937;
}

.status-indicator {
  width: 20px;
  height: 20px;
  border-radius: 50%;
}

.status-text {
  font-size: 14px;
  font-weight: 600;
  padding: 4px 8px;
  border-radius: 4px;
}

.description-header {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 16px;
}

.description-title {
  margin: 0;
  font-size: 18px;
  font-weight: 600;
  color: #1f2937;
}

.description-text {
  margin: 0;
  font-size: 16px;
  line-height: 1.6;
  color: #4b5563;
}

.metadata-title {
  margin: 0 0 20px 0;
  font-size: 18px;
  font-weight: 600;
  color: #1f2937;
}

/* .metadata-items-container {
  display: flex;
  flex-direction: column;
  gap: 16px;
} */

/* .metadata-item {
  display: flex;
  align-items: center;
  gap: 12px;
}

.metadata-icon {
  color: #6b7280;
}

.metadata-label {
  font-size: 14px;
  color: #6b7280;
  font-weight: 500;
  min-width: 100px;
} */

/* .metadata-value {
  font-size: 14px;
  color: #1f2937;
}

.product-id {
  font-family: monospace;
  background-color: #f3f4f6;
  padding: 2px 6px;
  border-radius: 4px;
} */

/* Responsive design */
/* @media (max-width: 968px) {
  .product-content {
    grid-template-columns: 1fr;
  }

  .main-image {
    height: 350px;
  }
} */

/* @media (max-width: 640px) {
  .product-header {
    flex-direction: column;
    align-items: flex-start;
    gap: 16px;
  }

  .header-buttons {
    width: 100%;
    justify-content: space-between;
  }

  .edit-button,
  .delete-button {
    flex: 1;
    justify-content: center;
  }

  .main-image {
    height: 300px;
  }
} */
`, "",{"version":3,"sources":["webpack://./src/pages/ProductDetailsPage/ProductDetailsPage.css"],"names":[],"mappings":"AAAA,2BAA2B;AAC3B;EACE,8EAA8E;EAC9E,yBAAyB;EACzB,aAAa;EACb,aAAa;AACf;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,mBAAmB;EACnB,wCAAwC;AAC1C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,6BAA6B;EAC7B,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,cAAc;EACd,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;EAClB,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;EAClB,6BAA6B;EAC7B,cAAc;EACd,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;EACT,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;EACb,wCAAwC;AAC1C;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,aAAa;EACb,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,2BAA2B;EAC3B,oCAAoC;EACpC,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,aAAa;EACb,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,6BAA6B;EAC7B,yBAAyB;AAC3B;;AAEA;EACE,YAAY;EACZ,sBAAsB;AACxB;;AAEA;EACE,yBAAyB;EACzB,UAAU;AACZ;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,aAAa;EACb,wCAAwC;AAC1C;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;;;;GAIG;;AAEH;;;;;;;;;;;;;;;GAeG;;AAEH;;;;;;;;;;GAUG;;AAEH,sBAAsB;AACtB;;;;;;;;GAQG;;AAEH;;;;;;;;;;;;;;;;;;;;;GAqBG","sourcesContent":["/* ProductDetailsPage.css */\n.product-details-container {\n  font-family: -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, sans-serif;\n  background-color: #f8fafc;\n  min-height: 0;\n  padding: 24px;\n}\n\n.product-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  margin-bottom: 32px;\n  background-color: white;\n  padding: 20px 24px;\n  border-radius: 12px;\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);\n}\n\n.header-left {\n  display: flex;\n  align-items: center;\n  gap: 16px;\n}\n\n.back-button {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  padding: 8px 16px;\n  background-color: transparent;\n  border: 1px solid #e5e7eb;\n  border-radius: 8px;\n  cursor: pointer;\n  color: #6b7280;\n  font-size: 14px;\n  transition: all 0.2s ease;\n}\n\n.back-button:hover {\n  background-color: #f9fafb;\n}\n\n.header-title {\n  margin: 0;\n  font-size: 24px;\n  font-weight: 600;\n  color: #1f2937;\n}\n\n.header-buttons {\n  display: flex;\n  gap: 12px;\n}\n\n.edit-button {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  padding: 10px 16px;\n  background-color: #ff6b35;\n  color: white;\n  border: none;\n  border-radius: 8px;\n  cursor: pointer;\n  font-size: 14px;\n  font-weight: 500;\n  transition: all 0.2s ease;\n}\n\n.edit-button:hover {\n  background-color: #e55a2b;\n}\n\n.delete-button {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  padding: 10px 16px;\n  background-color: transparent;\n  color: #ef4444;\n  border: 1px solid #ef4444;\n  border-radius: 8px;\n  cursor: pointer;\n  font-size: 14px;\n  font-weight: 500;\n  transition: all 0.2s ease;\n}\n\n.delete-button:hover {\n  background-color: #fef2f2;\n}\n\n.product-content-con {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 32px;\n  max-width: 100%;\n  margin: 0 auto;\n}\n\n.images-container {\n  background-color: white;\n  border-radius: 12px;\n  padding: 24px;\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);\n}\n\n.images-title {\n  margin: 0 0 20px 0;\n  font-size: 18px;\n  font-weight: 600;\n  color: #1f2937;\n}\n\n.main-image-container {\n  position: relative;\n  margin-bottom: 16px;\n  border-radius: 8px;\n  overflow: hidden;\n  background-color: #f3f4f6;\n}\n\n.main-image {\n  width: 100%;\n  height: 400px;\n  object-fit: cover;\n  display: block;\n}\n\n.nav-button {\n  position: absolute;\n  top: 50%;\n  transform: translateY(-50%);\n  background-color: rgba(0, 0, 0, 0.6);\n  color: white;\n  border: none;\n  border-radius: 50%;\n  width: 40px;\n  height: 40px;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  transition: all 0.2s ease;\n}\n\n.nav-button:hover {\n  background-color: rgba(0, 0, 0, 0.8);\n}\n\n.prev-button {\n  left: 12px;\n}\n\n.next-button {\n  right: 12px;\n}\n\n.thumbnails-container {\n  display: flex;\n  gap: 12px;\n  flex-wrap: wrap;\n}\n\n.thumbnail {\n  width: 80px;\n  height: 80px;\n  object-fit: cover;\n  border-radius: 6px;\n  cursor: pointer;\n  border: 2px solid transparent;\n  transition: all 0.2s ease;\n}\n\n.thumbnail:hover {\n  opacity: 0.9;\n  transform: scale(1.05);\n}\n\n.thumbnail-active {\n  border: 2px solid #ff6b35;\n  opacity: 1;\n}\n\n.thumbnail-inactive {\n  opacity: 0.7;\n}\n\n.info-column {\n  display: flex;\n  flex-direction: column;\n  gap: 24px;\n}\n\n.info-card {\n  background-color: #fee2e2;\n  border-radius: 12px;\n  padding: 24px;\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);\n}\n\n.product-name {\n  margin: 0 0 20px 0;\n  font-size: 28px;\n  font-weight: 700;\n  color: #1f2937;\n}\n\n.info-items-container {\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n}\n\n.info-item {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n}\n\n.info-icon {\n  color: #6b7280;\n}\n\n.info-text {\n  font-size: 16px;\n  color: #6b7280;\n  font-weight: 500;\n}\n\n.price-text {\n  font-size: 24px;\n  font-weight: 700;\n  color: #10b981;\n}\n\n.quantity-text {\n  font-size: 18px;\n  font-weight: 600;\n  color: #1f2937;\n}\n\n.status-indicator {\n  width: 20px;\n  height: 20px;\n  border-radius: 50%;\n}\n\n.status-text {\n  font-size: 14px;\n  font-weight: 600;\n  padding: 4px 8px;\n  border-radius: 4px;\n}\n\n.description-header {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  margin-bottom: 16px;\n}\n\n.description-title {\n  margin: 0;\n  font-size: 18px;\n  font-weight: 600;\n  color: #1f2937;\n}\n\n.description-text {\n  margin: 0;\n  font-size: 16px;\n  line-height: 1.6;\n  color: #4b5563;\n}\n\n.metadata-title {\n  margin: 0 0 20px 0;\n  font-size: 18px;\n  font-weight: 600;\n  color: #1f2937;\n}\n\n/* .metadata-items-container {\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n} */\n\n/* .metadata-item {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n}\n\n.metadata-icon {\n  color: #6b7280;\n}\n\n.metadata-label {\n  font-size: 14px;\n  color: #6b7280;\n  font-weight: 500;\n  min-width: 100px;\n} */\n\n/* .metadata-value {\n  font-size: 14px;\n  color: #1f2937;\n}\n\n.product-id {\n  font-family: monospace;\n  background-color: #f3f4f6;\n  padding: 2px 6px;\n  border-radius: 4px;\n} */\n\n/* Responsive design */\n/* @media (max-width: 968px) {\n  .product-content {\n    grid-template-columns: 1fr;\n  }\n\n  .main-image {\n    height: 350px;\n  }\n} */\n\n/* @media (max-width: 640px) {\n  .product-header {\n    flex-direction: column;\n    align-items: flex-start;\n    gap: 16px;\n  }\n\n  .header-buttons {\n    width: 100%;\n    justify-content: space-between;\n  }\n\n  .edit-button,\n  .delete-button {\n    flex: 1;\n    justify-content: center;\n  }\n\n  .main-image {\n    height: 300px;\n  }\n} */\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
